exports.REPORT_BALANCE_FIELD_SHORT = 'field:standard-physical-count'
exports.REPORT_BALANCE_FIELD = 'fields.field:standard-physical-count.amount'
exports.REPORT_CAMPAIGN_BALANCE_FIELD = 'campaign:sia.amount'
exports.VAN_SERVICE_ID = 'program:immunization:service:immunization'
exports.SHELFLIFE_PROGRAM_ID = 'program:shelflife'
exports.BASIC_TIER_SUFFIX = '-basic-tier'
exports.PARTNER_BALANCE_FIELD_SHORT = 'field:partner-balance'
exports.PARTNER_BALANCE_FIELD = 'fields.field:partner-balance.amount'
exports.SHELFLIFE_BALANCE_FIELD = 'fields.field:shelflife-balance.amount'
exports.EXPIRY_DETAILS_FIELD = 'fields.field:expiry'
